



















































































import { Color, Flg, MukoKb } from '@/constants/constants';
import Vue from 'vue';
import { formatNumber } from '@/utils/utils';

export default Vue.extend<any, any, any, any>({
  name: 'G_040_HatchuConfirm_ChildHeaderInput_Table',
  components: {
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    suryoSum: {
      type: Number,
      default: 0,
    },
    juryoSum: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    Flg,
    Color,
    MukoKb,
    headers: [
      {
        text: '№',
        value: 'numberOrder',
        class: 'text-end',
        cellClass: 'text-end',
        width: 45,
        sortable: false,
      },
      {
        text: '品目',
        value: 'himmokuCd',
        width: 80,
        sortable: false,
      },
      {
        text: '',
        value: 'himmokuMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        width: 400,
        sortable: false,
      },
      {
        text: '単位',
        value: 'tani',
        width: 50,
        sortable: false,
      },
      {
        text: '入数',
        value: 'irisu',
        class: 'text-end',
        cellClass: 'text-end',
        width: 60,
        sortable: false,
      },
      {
        text: '数量',
        value: 'suryo',
        class: 'text-end',
        cellClass: 'text-end',
        width: 100,
        sortable: false,
      },
      {
        text: '重量',
        value: 'juryo',
        class: 'text-end',
        cellClass: 'text-end',
        width: 120,
        sortable: false,
      },
      {
        text: '明細備考',
        value: 'meisaiBiko',
        width: 500,
        sortable: false,
      },
    ],
  }),
  methods: {
    formatNumber,
  },
  computed: {
    tableHeight() {
      return this.$vuetify.breakpoint.height - 590;
    },
  },
});
